function setVersionAction(version) {
	return {
		type: "version/set",
		payload: {
			data: version,
			initialized: true,
		},
	};
}

export default function setVersion(version={}, goTo) {
	return async (dispatch) => {
		dispatch(setVersionAction(version));

		const versionSession = sessionStorage.getItem("version");
		const storedVersion = versionSession && versionSession!== "undefined" && JSON.parse(versionSession);

		if (version?.status === "OK" && storedVersion?.status !== "OK") {
			sessionStorage.setItem("banner", true);
		}

		sessionStorage.setItem("version", JSON.stringify(version));
	};
}
